import storage from "../services/storage";
import { InitialState } from "./types";

const machinesTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
  ? "dark"
  : "light";

const storedToken = storage.get("token") || "";
const storedAddress = storage.get("address") || "";
const storedPublicKey = storage.get("publicKey") || "";
const storedTheme = storage.get("theme") || machinesTheme;

const initialState: InitialState = {
  authState: {
    token: storedToken,
    address: storedAddress,
    publicKey: storedPublicKey,
  },
  marketState: {
    ownAssets: null,
    markets: null,
    coinInfo: null,
  },
  settingsState: {
    theme: storedTheme,
  },
  walletState: {
    address: null,
    balance: null,
    confirmations: null,
  },
};

export default initialState;
